import { useTranslation } from "react-i18next";
import styled from "styled-components";

import WhatHappensNext from "./WhatHappensNext";

import getImageUrl from "utils/getImageUrl";

const CustomWhatHappensNextBasket = styled.div`
  padding: 0 0 77px 0;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    padding: 64px 0;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    padding: 80px 0;
  }
`;

const CustomWhatHappensNextCheckout = styled.div`
  padding: 0 0 77px 0;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    padding: 53px 0 40px 0;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    padding: 53px 0 40px 0;
  }
`;

export const WhatHappensNextBasket = () => {
  const { t } = useTranslation();

  const content = [
    {
      img: getImageUrl("/images/icons/checkout.png"),
      text: t(
        "1. We'll move on to the checkout page where you will be able to see a total breakdown of your purchases.",
      ),
    },
    {
      img: getImageUrl("/images/icons/settings.png"),
      text: t(
        "2. Once you are happy with your purchases, we will proceed to setup your subscriptions. Setup between products may differ depending on the service you have purchased.",
      ),
    },
    {
      img: getImageUrl("/images/icons/play.png"),
      text: t("3. Enjoy the content from your service provider."),
    },
  ];

  return (
    <CustomWhatHappensNextBasket>
      <WhatHappensNext content={content} />
    </CustomWhatHappensNextBasket>
  );
};

export const WhatHappensNextCheckout = () => {
  const { t } = useTranslation();

  const content = [
    {
      img: getImageUrl("/images/icons/checkout.png"),
      text: t(
        "1. We will charge your subscriptions to your next Vodafone bill. If you are taking subscriptions with a free trial, you will not be billed until after the trial.",
      ),
    },
    {
      img: getImageUrl("/images/icons/settings.png"),
      text: t(
        "2. Once you are happy with your purchases, we will proceed to setup your subscriptions. Setup between products may differ depending on the service you have purchased.",
      ),
    },
    {
      img: getImageUrl("/images/icons/play.png"),
      text: t("3. Enjoy the content from your service provider."),
    },
  ];

  return (
    <CustomWhatHappensNextCheckout>
      <WhatHappensNext content={content} />
    </CustomWhatHappensNextCheckout>
  );
};

export default WhatHappensNext;
